module.exports = __webpack_public_path__ + "static/media/aboutus.bf7ecc5d.jpg";